import { gql } from '@apollo/client';
import { BUSINESS_DETAIL_FIELDS_FRAGMENT } from './businessDetailFieldsFragment.gql';

const BUSINESS_DETAIL_CREATE_SUBSCRIPTION = gql`
  ${BUSINESS_DETAIL_FIELDS_FRAGMENT}
  subscription onCreateBusinessDetail($input: BusinessDetailSubscriptionFilterInput) {
    onCreateBusinessDetail(input: $input) {
      ...BusinessDetailFields
    }
  }
`;

const BUSINESS_DETAIL_UPDATE_SUBSCRIPTION = gql`
  ${BUSINESS_DETAIL_FIELDS_FRAGMENT}
  subscription onUpdateBusinessDetail($input: BusinessDetailSubscriptionFilterInput) {
    onUpdateBusinessDetail(input: $input) {
      ...BusinessDetailFields
    }
  }
`;

const BUSINESS_DETAIL_ENTER_SUBSCRIPTION = gql`
  ${BUSINESS_DETAIL_FIELDS_FRAGMENT}
  subscription onEnterBusinessDetail($input: BusinessDetailSubscriptionFilterInput) {
    onEnterBusinessDetail(input: $input) {
      ...BusinessDetailFields
    }
  }
`;

const BUSINESS_DETAIL_LEAVE_SUBSCRIPTION = gql`
  ${BUSINESS_DETAIL_FIELDS_FRAGMENT}
  subscription onLeaveBusinessDetail($input: BusinessDetailSubscriptionFilterInput) {
    onLeaveBusinessDetail(input: $input) {
      ...BusinessDetailFields
    }
  }
`;

export {
  BUSINESS_DETAIL_CREATE_SUBSCRIPTION,
  BUSINESS_DETAIL_UPDATE_SUBSCRIPTION,
  BUSINESS_DETAIL_ENTER_SUBSCRIPTION,
  BUSINESS_DETAIL_LEAVE_SUBSCRIPTION,
};
